export const isString = (str: any) => typeof str === 'string'

export const getFirstLetter = (str: any = '') => {
  if (!isString(str)) return ''
  return str.charAt(0)
}
